module.exports = __webpack_public_path__ + "static/media/notification.22486116.svg";